// Comprehensive Country to Currency Map
export const COUNTRY_CURRENCY_MAP = {
    AF: 'AFN', AL: 'ALL', DZ: 'DZD', AS: 'USD', AD: 'EUR', AO: 'AOA', AI: 'XCD', AG: 'XCD', AR: 'ARS', AM: 'AMD', AW: 'AWG', AU: 'AUD', AT: 'EUR', AZ: 'AZN',
    BS: 'BSD', BH: 'BHD', BD: 'BDT', BB: 'BBD', BY: 'BYN', BE: 'EUR', BZ: 'BZD', BJ: 'XOF', BM: 'BMD', BT: 'BTN', BO: 'BOB', BA: 'BAM', BW: 'BWP', BR: 'BRL',
    IO: 'USD', VG: 'USD', BN: 'BND', BG: 'BGN', BF: 'XOF', BI: 'BIF', KH: 'KHR', CM: 'XAF', CA: 'CAD', CV: 'CVE', KY: 'KYD', CF: 'XAF', TD: 'XAF', CL: 'CLP',
    CN: 'CNY', CX: 'AUD', CC: 'AUD', CO: 'COP', KM: 'KMF', CK: 'NZD', CR: 'CRC', HR: 'EUR', CU: 'CUP', CW: 'ANG', CY: 'EUR', CZ: 'CZK', CD: 'CDF', DK: 'DKK',
    DJ: 'DJF', DM: 'XCD', DO: 'DOP', EC: 'USD', EG: 'EGP', SV: 'USD', GQ: 'XAF', ER: 'ERN', EE: 'EUR', ET: 'ETB', FK: 'FKP', FO: 'DKK', FJ: 'FJD', FI: 'EUR',
    FR: 'EUR', GF: 'EUR', PF: 'XPF', TF: 'EUR', GA: 'XAF', GM: 'GMD', GE: 'GEL', DE: 'EUR', GH: 'GHS', GI: 'GIP', GR: 'EUR', GL: 'DKK', GD: 'XCD', GP: 'EUR',
    GU: 'USD', GT: 'GTQ', GG: 'GBP', GN: 'GNF', GW: 'XOF', GY: 'GYD', HT: 'HTG', HN: 'HNL', HK: 'HKD', HU: 'HUF', IS: 'ISK', IN: 'INR', ID: 'IDR', IR: 'IRR',
    IQ: 'IQD', IE: 'EUR', IM: 'GBP', IL: 'ILS', IT: 'EUR', CI: 'XOF', JM: 'JMD', JP: 'JPY', JE: 'GBP', JO: 'JOD', KZ: 'KZT', KE: 'KES', KI: 'AUD', XK: 'EUR',
    KW: 'KWD', KG: 'KGS', LA: 'LAK', LV: 'EUR', LB: 'LBP', LS: 'LSL', LR: 'LRD', LY: 'LYD', LI: 'CHF', LT: 'EUR', LU: 'EUR', MO: 'MOP', MK: 'MKD', MG: 'MGA',
    MW: 'MWK', MY: 'MYR', MV: 'MVR', ML: 'XOF', MT: 'EUR', MH: 'USD', MQ: 'EUR', MR: 'MRU', MU: 'MUR', YT: 'EUR', MX: 'MXN', FM: 'USD', MD: 'MDL', MC: 'EUR',
    MN: 'MNT', ME: 'EUR', MS: 'XCD', MA: 'MAD', MZ: 'MZN', MM: 'MMK', NA: 'NAD', NR: 'AUD', NP: 'NPR', NL: 'EUR', NC: 'XPF', NZ: 'NZD', NI: 'NIO', NE: 'XOF',
    NG: 'NGN', NU: 'NZD', NF: 'AUD', KP: 'KPW', MP: 'USD', NO: 'NOK', OM: 'OMR', PK: 'PKR', PW: 'USD', PS: 'ILS', PA: 'PAB', PG: 'PGK', PY: 'PYG', PE: 'PEN',
    PH: 'PHP', PN: 'NZD', PL: 'PLN', PT: 'EUR', PR: 'USD', QA: 'QAR', CG: 'XAF', RO: 'RON', RU: 'RUB', RW: 'RWF', RE: 'EUR', BL: 'EUR', SH: 'SHP', KN: 'XCD',
    LC: 'XCD', MF: 'EUR', PM: 'EUR', VC: 'XCD', WS: 'WST', SM: 'EUR', ST: 'STN', SA: 'SAR', SN: 'XOF', RS: 'RSD', SC: 'SCR', SL: 'SLL', SG: 'SGD', SX: 'ANG',
    SK: 'EUR', SI: 'EUR', SB: 'SBD', SO: 'SOS', ZA: 'ZAR', GS: 'GBP', KR: 'KRW', SS: 'SSP', ES: 'EUR', LK: 'LKR', SD: 'SDG', SR: 'SRD', SJ: 'NOK', SZ: 'SZL',
    SE: 'SEK', CH: 'CHF', SY: 'SYP', TW: 'TWD', TJ: 'TJS', TZ: 'TZS', TH: 'THB', TL: 'USD', TG: 'XOF', TK: 'NZD', TO: 'TOP', TT: 'TTD', TN: 'TND', TR: 'TRY',
    TM: 'TMT', TC: 'USD', TV: 'AUD', UG: 'UGX', UA: 'UAH', AE: 'AED', GB: 'GBP', US: 'USD', UY: 'UYU', UM: 'USD', VI: 'USD', UZ: 'UZS', VU: 'VUV', VA: 'EUR',
    VE: 'VES', VN: 'VND', WF: 'XPF', EH: 'MAD', YE: 'YER', ZM: 'ZMW', ZW: 'ZWL'
};

export const CURRENCY_LABELS = {
    AED: 'AED (د.إ) - United Arab Emirates Dirham',
    AFN: 'AFN (؋) - Afghan Afghani',
    ALL: 'ALL (L) - Albanian Lek',
    AMD: 'AMD (֏) - Armenian Dram',
    ANG: 'ANG (ƒ) - Netherlands Antillean Guilder',
    AOA: 'AOA (Kz) - Angolan Kwanza',
    ARS: 'ARS ($) - Argentine Peso',
    AUD: 'AUD (A$) - Australian Dollar',
    AWG: 'AWG (ƒ) - Aruban Florin',
    AZN: 'AZN (₼) - Azerbaijani Manat',
    BAM: 'BAM (KM) - Bosnia-Herzegovina Convertible Mark',
    BBD: 'BBD ($) - Barbadian Dollar',
    BDT: 'BDT (৳) - Bangladeshi Taka',
    BGN: 'BGN (лв) - Bulgarian Lev',
    BHD: 'BHD (.د.ب) - Bahraini Dinar',
    BIF: 'BIF (FBu) - Burundian Franc',
    BMD: 'BMD ($) - Bermudan Dollar',
    BND: 'BND ($) - Brunei Dollar',
    BOB: 'BOB (Bs.) - Bolivian Boliviano',
    BRL: 'BRL (R$) - Brazilian Real',
    BSD: 'BSD ($) - Bahamian Dollar',
    BTN: 'BTN (Nu.) - Bhutanese Ngultrum',
    BWP: 'BWP (P) - Botswanan Pula',
    BYN: 'BYN (Br) - Belarusian Ruble',
    BZD: 'BZD ($) - Belize Dollar',
    CAD: 'CAD (C$) - Canadian Dollar',
    CDF: 'CDF (FC) - Congolese Franc',
    CHF: 'CHF (CHF) - Swiss Franc',
    CLP: 'CLP ($) - Chilean Peso',
    CNY: 'CNY (¥) - Chinese Yuan',
    COP: 'COP ($) - Colombian Peso',
    CRC: 'CRC (₡) - Costa Rican Colón',
    CUP: 'CUP ($) - Cuban Peso',
    CVE: 'CVE ($) - Cape Verdean Escudo',
    CZK: 'CZK (Kč) - Czech Koruna',
    DJF: 'DJF (Fdj) - Djiboutian Franc',
    DKK: 'DKK (kr) - Danish Krone',
    DOP: 'DOP ($) - Dominican Peso',
    DZD: 'DZD (د.ج) - Algerian Dinar',
    EGP: 'EGP (E£) - Egyptian Pound',
    ERN: 'ERN (Nfk) - Eritrean Nakfa',
    ETB: 'ETB (Br) - Ethiopian Birr',
    EUR: 'EUR (€) - Euro',
    FJD: 'FJD ($) - Fijian Dollar',
    FKP: 'FKP (£) - Falkland Islands Pound',
    GBP: 'GBP (£) - British Pound Sterling',
    GEL: 'GEL (₾) - Georgian Lari',
    GHS: 'GHS (GH₵) - Ghanaian Cedi',
    GIP: 'GIP (£) - Gibraltar Pound',
    GMD: 'GMD (D) - Gambian Dalasi',
    GNF: 'GNF (FG) - Guinean Franc',
    GTQ: 'GTQ (Q) - Guatemalan Quetzal',
    GYD: 'GYD ($) - Guyanaese Dollar',
    HKD: 'HKD ($) - Hong Kong Dollar',
    HNL: 'HNL (L) - Honduran Lempira',
    HRK: 'HRK (kn) - Croatian Kuna',
    HTG: 'HTG (G) - Haitian Gourde',
    HUF: 'HUF (Ft) - Hungarian Forint',
    IDR: 'IDR (Rp) - Indonesian Rupiah',
    ILS: 'ILS (₪) - Israeli New Sheqel',
    INR: 'INR (₹) - Indian Rupee',
    IQD: 'IQD (ع.د) - Iraqi Dinar',
    IRR: 'IRR (﷼) - Iranian Rial',
    ISK: 'ISK (kr) - Icelandic Króna',
    JMD: 'JMD ($) - Jamaican Dollar',
    JOD: 'JOD (د.ا) - Jordanian Dinar',
    JPY: 'JPY (¥) - Japanese Yen',
    KES: 'KES (KSh) - Kenyan Shilling',
    KGS: 'KGS (с) - Kyrgystani Som',
    KHR: 'KHR (៛) - Cambodian Riel',
    KMF: 'KMF (CF) - Comorian Franc',
    KPW: 'KPW (₩) - North Korean Won',
    KRW: 'KRW (₩) - South Korean Won',
    KWD: 'KWD (د.ك) - Kuwaiti Dinar',
    KYD: 'KYD ($) - Cayman Islands Dollar',
    KZT: 'KZT (₸) - Kazakhstani Tenge',
    LAK: 'LAK (₭) - Laotian Kip',
    LBP: 'LBP (ل.ل) - Lebanese Pound',
    LKR: 'LKR (Rs) - Sri Lankan Rupee',
    LRD: 'LRD ($) - Liberian Dollar',
    LSL: 'LSL (L) - Lesotho Loti',
    LYD: 'LYD (ل.د) - Libyan Dinar',
    MAD: 'MAD (dh) - Moroccan Dirham',
    MDL: 'MDL (L) - Moldovan Leu',
    MGA: 'MGA (Ar) - Malagasy Ariary',
    MKD: 'MKD (ден) - Macedonian Denar',
    MMK: 'MMK (K) - Myanma Kyat',
    MNT: 'MNT (₮) - Mongolian Tugrik',
    MOP: 'MOP (P) - Macanese Pataca',
    MRU: 'MRU (UM) - Mauritanian Ouguiya',
    MUR: 'MUR (Rs) - Mauritian Rupee',
    MVR: 'MVR (Rf) - Maldivian Rufiyaa',
    MWK: 'MWK (MK) - Malawian Kwacha',
    MXN: 'MXN ($) - Mexican Peso',
    MYR: 'MYR (RM) - Malaysian Ringgit',
    MZN: 'MZN (MT) - Mozambican Metical',
    NAD: 'NAD ($) - Namibian Dollar',
    NGN: 'NGN (₦) - Nigerian Naira',
    NIO: 'NIO (C$) - Nicaraguan Córdoba',
    NOK: 'NOK (kr) - Norwegian Krone',
    NPR: 'NPR (Rs) - Nepalese Rupee',
    NZD: 'NZD ($) - New Zealand Dollar',
    OMR: 'OMR (ر.ع.) - Omani Rial',
    PAB: 'PAB (B/.) - Panamanian Balboa',
    PEN: 'PEN (S/.) - Peruvian Nuevo Sol',
    PGK: 'PGK (K) - Papua New Guinean Kina',
    PHP: 'PHP (₱) - Philippine Peso',
    PKR: 'PKR (Rs) - Pakistani Rupee',
    PLN: 'PLN (zł) - Polish Zloty',
    PYG: 'PYG (₲) - Paraguayan Guarani',
    QAR: 'QAR (ر.ق) - Qatari Rial',
    RON: 'RON (lei) - Romanian Leu',
    RSD: 'RSD (дин.) - Serbian Dinar',
    RUB: 'RUB (₽) - Russian Ruble',
    RWF: 'RWF (FRw) - Rwandan Franc',
    SAR: 'SAR (ر.س) - Saudi Riyal',
    SBD: 'SBD ($) - Solomon Islands Dollar',
    SCR: 'SCR (₨) - Seychellois Rupee',
    SDG: 'SDG (ج.س.) - Sudanese Pound',
    SEK: 'SEK (kr) - Swedish Krona',
    SGD: 'SGD (S$) - Singapore Dollar',
    SHP: 'SHP (£) - Saint Helena Pound',
    SLL: 'SLL (Le) - Sierra Leonean Leone',
    SOS: 'SOS (Sh) - Somali Shilling',
    SRD: 'SRD ($) - Surinamese Dollar',
    SSP: 'SSP (£) - South Sudanese Pound',
    STN: 'STN (Db) - São Tomé and Príncipe Dobra',
    SYP: 'SYP (£) - Syrian Pound',
    SZL: 'SZL (L) - Swazi Lilangeni',
    THB: 'THB (฿) - Thai Baht',
    TJS: 'TJS (SM) - Tajikistani Somoni',
    TMT: 'TMT (m) - Turkmenistani Manat',
    TND: 'TND (د.ت) - Tunisian Dinar',
    TOP: 'TOP (T$) - Tongan Paʻanga',
    TRY: 'TRY (₺) - Turkish Lira',
    TTD: 'TTD ($) - Trinidad and Tobago Dollar',
    TWD: 'TWD (NT$) - New Taiwan Dollar',
    TZS: 'TZS (Sh) - Tanzanian Shilling',
    UAH: 'UAH (₴) - Ukrainian Hryvnia',
    UGX: 'UGX (USh) - Ugandan Shilling',
    USD: 'USD ($) - United States Dollar',
    UYU: 'UYU ($U) - Uruguayan Peso',
    UZS: 'UZS (so\'m) - Uzbekistan Som',
    VES: 'VES (Bs.S) - Venezuelan Bolívar',
    VND: 'VND (₫) - Vietnamese Dong',
    VUV: 'VUV (Vt) - Vanuatu Vatu',
    WST: 'WST (T) - Samoan Tala',
    XAF: 'XAF (FCFA) - CFA Franc BEAC',
    XCD: 'XCD ($) - East Caribbean Dollar',
    XOF: 'XOF (CFA) - CFA Franc BCEAO',
    XPF: 'XPF (₣) - CFP Franc',
    YER: 'YER (﷼) - Yemeni Rial',
    ZAR: 'ZAR (R) - South African Rand',
    ZMW: 'ZMW (ZK) - Zambian Kwacha',
    ZWL: 'ZWL ($) - Zimbabwean Dollar'
};
